import { ecoFarm } from 'config/constants/ecoBoost'
import { MAX_TOTAL_BOOST_FACTOR } from 'config/constants/farmBoost'
import farms from 'config/constants/farms'
import { isFarmBoostingSupported, isEcoFarmSupported } from './isNftStakingSupported'

export const getMaxEcoBoostFactor = (pid) => {
  if (isEcoFarmSupported(pid)) {
    const targetFarm = farms.find((farm) => farm.pid === pid)
    const { maxStakedNum = 0, boostFactorPerNFT = 0 } = ecoFarm[targetFarm?.ecoFarm]
    return 1 + maxStakedNum * boostFactorPerNFT
  }
  return 1
}

export const getMaxFarmBoostFactor = (pid) => {
  if (isFarmBoostingSupported(pid)) {
    return MAX_TOTAL_BOOST_FACTOR
  }
  return 1
}
